module.exports = __webpack_public_path__ + "static/media/empty-cart.dc516550.svg";